import { render, staticRenderFns } from "./nav-org-list.vue?vue&type=template&id=56c8748f&scoped=true"
import script from "./nav-org-list.vue?vue&type=script&lang=js"
export * from "./nav-org-list.vue?vue&type=script&lang=js"
import style0 from "./nav-org-list.vue?vue&type=style&index=0&id=56c8748f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8748f",
  null
  
)

export default component.exports